import { SettingsField } from 'src/types/page-generator';

import commonContentFields from '../../common/contentFields';

const contentFields: SettingsField[] = [...commonContentFields];

export default contentFields;
